import React from "react";

const SecondPlace = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28.051"
    height="36.688"
    viewBox="0 0 28.051 36.688">
    <defs />
    <g id="Group_9145" transform="translate(-2853.156 -632.244)">
      <path
        id="Path_15241"
        d="M2298.555 187.392l-9.742-4.16-9.741 4.16V162.7h19.483z"
        className="cls-2-mobile"
        transform="translate(578.316 481.54)"
      />
      <path
        id="Path_15240"
        fill="#d4d1c5"
        d="M14.026 0A14.026 14.026 0 1 1 0 14.026 14.026 14.026 0 0 1 14.026 0z"
        transform="translate(2853.156 632.244)"
      />
      <circle
        id="Ellipse_1718"
        cx="10.786"
        cy="10.786"
        r="10.786"
        className="cls-2-mobile"
        transform="translate(2856.344 635.484)"
      />
      <text
        id="_2"
        fill="#d4d1c5"
        fontFamily="Roboto-Black, Roboto"
        fontSize="14px"
        fontWeight="800"
        transform="translate(2863.482 650.612)">
        <tspan x="0" y="0">
          2
        </tspan>
      </text>
    </g>
  </svg>
);

export default SecondPlace;
